'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nChildren = {};

exports.__exports = nChildren;
